const subscription = {
    limit_exceeded: 'You have reached the limit of your subscription plan.',
    get_plan_failed: 'Unable to get subscription plan for tenant.',
    tenant_suspended: 'Tenant is suspended. Please contact your administrator.',
};
export default Object.freeze(subscription);
